import React from "react";
import PropTypes from "prop-types";
import { Flex, FlexItem, Button, Small } from "orcs-design-system";
import { numberToLocaleString } from "src/util/toLocaleString";

const ShowMore = (props) => {
  const {
    cardTotalCount,
    countItems,
    countSum,
    onShowMore,
    label = "",
    itemCount,
  } = props;
  if (countItems > 0) {
    return (
      <Flex justifyContent="space-between" alignItems="center" mt="r">
        <Button variant="ghost" small onClick={onShowMore}>
          + Show {countItems} more {label}
        </Button>
        <FlexItem>
          <Small>
            Showing {itemCount} of {numberToLocaleString(countSum)} {label}
          </Small>
        </FlexItem>
      </Flex>
    );
  }
  if (cardTotalCount > 100) {
    return (
      <Small fontWeight="bold" py="s">
        NOTE: {numberToLocaleString(cardTotalCount - 100)} more {label}{" "}
        available. Please use filters to narrow down your search.
      </Small>
    );
  }
  return null;
};

ShowMore.propTypes = {
  cardTotalCount: PropTypes.number.isRequired,
  countItems: PropTypes.number.isRequired,
  countSum: PropTypes.number.isRequired,
  onShowMore: PropTypes.func.isRequired,
  itemCount: PropTypes.number.isRequired,
  label: PropTypes.string,
};

export default ShowMore;
